// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kCaL","left":"styles_left__12lZC","desktopActions":"styles_desktopActions__wwzXl","title":"styles_title__3vNgi"};